import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ContentVideoListItem } from "../../content.types";
import { requestCreateVideo } from "./createVideo.request";

const useCreateVideo = (
  options?: MutationOptions<ContentVideoListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateVideo,
    ...options
  });
};

export default useCreateVideo;
